<div class="w-full" style="width: 30vw !important">
    <form [formGroup]="newFolderForm" class="h-full overflow-y-none p-4" autocomplete="off">
        <div class="w-full">
          <mat-form-field appearance="fill" ngClass="w-full" [hideRequiredMarker]="true" [floatLabel]="'always'">
            <mat-label class="primary-font font-semibold text-lg">{{'text.folder.name' | translate}}</mat-label>
              <input
                  #folderNameInput
                  matInput
                  id="reason"
                  [spellcheck]="false"
                  formControlName="newFolder"
                  (keydown.enter)="submit()"
                   />
          </mat-form-field>
          <p class="text-red-500 text-base" *ngIf="utilityService.getErrorMessage(newFolderForm, 'newFolder')">{{utilityService.getErrorMessage(newFolderForm, 'newFolder') | translate}}</p>    

        </div>
      </form>
    </div>
    <div class="flex justify-end zuper-dialog-footer">
      <div class="flex justify-around space-x-4">
          <button type="button" mat-stroked-button mat-dialog-close class="px-6 items-center py-2 border b-1 btn-small border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text' | translate}}</button>
          <button
          (click)="submit()"
          [disabled]="isLoading"
          class="btn-small flex items-center bg-primary px-6 items-center py-2 border b-1 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none">
          <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
          <span>{{ (dialogData?.action === 'new' ? 'create' : 'update') | translate }}</span>
        </button>
      </div>
    </div>

